import { MenuItem, Select } from '@mui/material';

import { useSelector } from 'react-redux';
import { useState } from 'react';
import { selectMonth } from '../helper/filterReceipt';
import { useEffect } from 'react';

const FilterReceiptByMonth = ({ setAllVendorReceiptsData }) => {
  const { allVendorReceiptData } = useSelector((state) => state.vendorReceipt);
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1;
  const currentYear = currentDate.getFullYear(); 
  const [defaultSelect, setDefaultSelect] = useState(`${currentMonth}-${currentYear}`);

  const handleSelect = async (event) => {
    const [month, year] = event.target.value.split("-").map(Number);
    const monthYearData = { month, year };
    setDefaultSelect(`${month}-${year}`);
    const seletctedData = await selectMonth(monthYearData, allVendorReceiptData.data.data);
    setAllVendorReceiptsData(seletctedData);
  };

  // Effect to filter data on component mount
  useEffect(() => {
    const filterInitialData = async () => {
      const [month, year] = defaultSelect.split('-').map(Number);
      const monthYearData = { month, year };
      
      const selectedData = await selectMonth(monthYearData,allVendorReceiptData.data.data);
      setAllVendorReceiptsData(selectedData);
    };

    filterInitialData();
  }, [defaultSelect, allVendorReceiptData, setAllVendorReceiptsData]); // Dependencies for useEffect

  return (
    <Select size='small' value={defaultSelect} onChange={handleSelect}>
      <MenuItem value={`${0}-${0}`} id={`${'all'}-${'all'}`}>
        Select Month
      </MenuItem>

      <MenuItem value={`${currentMonth}-${currentYear}`} id={`${currentMonth}-${currentYear}`}>
        This Month
      </MenuItem>

      <MenuItem
         value={`${currentMonth === 1 ? 12 : currentMonth - 1}-${currentMonth === 1 ? currentYear - 1 : currentYear}`}
         id={`${currentMonth === 1 ? 12 : currentMonth - 1}-${currentMonth === 1 ? currentYear - 1 : currentYear}`}
      >
        Last Month
      </MenuItem>
    </Select>
  );
};

export default FilterReceiptByMonth;
